/* 🤖 this file was generated by svg-to-ts */
export const matIconForkRight: {
  name: 'fork-right';
  data: string;
} = {
  name: 'fork-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14.59 15.59 16 17l4-4-4-4-1.41 1.41L16.17 12c-1.51-.33-3.73.08-5.17 1.36V6.83l1.59 1.59L14 7l-4-4-4 4 1.41 1.41L9 6.83V21h2v-4c.73-2.58 3.07-3.47 5.17-3l-1.58 1.59z"/></svg>`
};
